import Language from './language';

//i18n_data
import fields from './i18n_data'

const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
    JP : () => `Username required.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
    JP : () => `Password required.`,
  }
};

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});
export default {
  props: ['history'],
  name: 'priceModal',
  data : () => ({
    so: default_opt()
  }),
  components: { Language },
  computed: {
    i18n_data() { return _i18n_data; },
    fields() {
      return fields.i18n_fields[this.i18n];
    },
  },
  methods: {
  },
  watch: { '$route' (to, from) { console.debug(from) } },
  created() { console.log('[Console] Billing history', 'created'); },
  destroyed() { console.log('[Console] Billing history', 'destroyed'); },
  mounted() { console.log('[Console] Billing history', 'mounted'); },
}
